export const validate = (values, props) => {

    const errors = {}
    if (values) {

        if (!values.names) {
            errors.names = 'Requerido'
        } else if (values.names.length < 2) {
            errors.names = 'El nombre ingresado es muy corto'
        }
        if (!values.surname) {
            errors.surname = 'Requerido'
        } else if (values.surname.length < 2) {
            errors.surname = 'El Apellido ingresado es muy corto'
        }

        if (!values.email) {
            errors.email = 'requerido'
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = 'El email ingresado no es válido';
        }

        if (!values.age) {
            errors.age = 'Requerido'
        } else if (isNaN(Number(values.age))) {
            errors.age = 'Debe ser un número'
        }
        if (!values.dni_type) {
            errors.dni_type = 'Requerido'
        }
        if (!values.dni) {
            errors.dni = 'Requerido'
        }
        if (!values.monotributo) {
            errors.monotributo = 'Requerido'
        }
        if (!values.cuit) {
            errors.cuit = 'Requerido'
        }
        if (!values.address) {
            errors.address = 'Requerido'
        }
        if (!values.location) {
            errors.location = 'Requerido'
        }
        if (!values.cp) {
            errors.cp = 'Requerido'
        }
        if (!values.telephone) {
            errors.telephone = 'Requerido'
        }
        if (!values.prefix_celphone) {
            errors.prefix_celphone = 'Requerido'
        }
        if (!values.celphone) {
            errors.celphone = 'Requerido'
        }
        if (!values.position) {
            errors.position = 'Requerido'
        }

        if (!values.level) {
            errors.level = 'Requerido'
        }
        if (!values.tablet_handling) {
            errors.tablet_handling = 'Requerido'
        }
        if (!values.box_holder) {
            errors.box_holder = 'Requerido'
        }

        if (!values.experience) {
            errors.experience = 'Requerido'
        }

    }

    return errors
}

export const warn = values => {
    const warnings = {}
    return warnings
}


// WEBPACK FOOTER //
// ./src/components/validation/validate.js